export function parseAgendaDate(value) {
  if (!value) {
    return null;
  }

  if (value instanceof Date) {
    const copy = new Date(value.getTime());
    return Number.isNaN(copy.getTime()) ? null : copy;
  }

  if (typeof value === "string") {
    const trimmed = value.trim();

    if (!trimmed) {
      return null;
    }

    let normalized = trimmed;

    if (/^\d{4}-\d{2}-\d{2}$/.test(trimmed)) {
      normalized = `${trimmed}T00:00:00`;
    } else if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}(:\d{2})?$/.test(trimmed)) {
      normalized = trimmed.replace(" ", "T");
    }

    const date = new Date(normalized);
    if (!Number.isNaN(date.getTime())) {
      return date;
    }
  }

  const fallback = new Date(value);
  return Number.isNaN(fallback.getTime()) ? null : fallback;
}

function pad(value) {
  return String(value).padStart(2, "0");
}

function toDateParts(date) {
  return {
    year: date.getFullYear(),
    month: pad(date.getMonth() + 1),
    day: pad(date.getDate()),
    hours: pad(date.getHours()),
    minutes: pad(date.getMinutes()),
    seconds: pad(date.getSeconds()),
  };
}

export function toDateKey(value) {
  const date = parseAgendaDate(value);

  if (!date) {
    return "";
  }

  const parts = toDateParts(date);
  return `${parts.year}-${parts.month}-${parts.day}`;
}

export function toInputDate(value) {
  return toDateKey(value);
}

export function shiftDate(value, amount) {
  const base = parseAgendaDate(value) || new Date();

  base.setHours(0, 0, 0, 0);
  base.setDate(base.getDate() + amount);

  return toInputDate(base);
}

export function formatTime(value) {
  const date = parseAgendaDate(value);

  if (!date) {
    return value ? String(value) : "";
  }

  return date.toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function formatDateTime(value) {
  const date = parseAgendaDate(value);

  if (!date) {
    return value ? String(value) : "";
  }

  return date.toLocaleString([], {
    year: "numeric",
    month: "short",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function toDateTimeLocalValue(value) {
  const date = parseAgendaDate(value);

  if (!date) {
    return "";
  }

  const parts = toDateParts(date);
  return `${parts.year}-${parts.month}-${parts.day}T${parts.hours}:${parts.minutes}`;
}

export function toApiDateTimeValue(value) {
  const date = parseAgendaDate(value);

  if (!date) {
    return "";
  }

  const parts = toDateParts(date);
  return `${parts.year}-${parts.month}-${parts.day} ${parts.hours}:${parts.minutes}:${parts.seconds}`;
}
